import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1863.52941,1016.43671 C1894.70118,1016.43671 1920,1041.73553 1920,1072.90729 L1920,1072.90729 L1920,1863.49553 C1920,1879.872 1912.88471,1895.34494 1900.68706,1905.96141 C1890.29647,1915.10965 1877.08235,1919.96612 1863.52941,1919.96612 C1861.04471,1919.96612 1858.44706,1919.85318 1855.96235,1919.51435 L1855.96235,1919.51435 L952.432941,1796.18259 C924.423529,1792.34259 903.529412,1768.39906 903.529412,1740.16376 L903.529412,1740.16376 L903.529412,1072.90729 C903.529412,1041.73553 928.828235,1016.43671 960,1016.43671 L960,1016.43671 Z M734.117647,1016.43671 C765.289412,1016.43671 790.588235,1041.73553 790.588235,1072.90729 L790.588235,1072.90729 L790.588235,1707.41082 C790.588235,1723.78729 783.472941,1739.26024 771.162353,1749.98965 C760.771765,1759.02494 747.670588,1763.88141 734.117647,1763.88141 C731.632941,1763.88141 728.922353,1763.76847 726.437647,1763.31671 L726.437647,1763.31671 L48.7905882,1669.34965 C20.7811765,1665.50965 0,1641.67906 0,1613.44376 L0,1613.44376 L0,1072.90729 C0,1041.73553 25.2988235,1016.43671 56.4705882,1016.43671 L56.4705882,1016.43671 Z M726.392471,156.581647 C742.543059,154.209882 758.806588,159.179294 771.117176,169.908706 C783.540706,180.638118 790.543059,196.224 790.543059,212.487529 L790.543059,212.487529 L790.543059,846.991059 C790.543059,878.275765 765.357176,903.461647 734.072471,903.461647 L734.072471,903.461647 L56.4254118,903.461647 C25.2536471,903.461647 -0.0451764706,878.275765 -0.0451764706,846.991059 L-0.0451764706,846.991059 L-0.0451764706,306.454588 C-0.0451764706,278.332235 20.736,254.388706 48.7454118,250.548706 L48.7454118,250.548706 Z M1855.97365,0.474352941 C1872.12424,-1.55858824 1888.38776,3.18494118 1900.69835,13.9143529 C1912.896,24.6437647 1920.01129,40.1167059 1920.01129,56.3802353 L1920.01129,56.3802353 L1920.01129,846.968471 C1920.01129,878.253176 1894.71247,903.439059 1863.54071,903.439059 L1863.54071,903.439059 L960.011294,903.439059 C928.839529,903.439059 903.540706,878.253176 903.540706,846.968471 L903.540706,846.968471 L903.540706,179.712 C903.540706,151.476706 924.321882,127.646118 952.444235,123.806118 L952.444235,123.806118 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWindowsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconWindowsSolid, _Component);

  var _super = _createSuper(IconWindowsSolid);

  function IconWindowsSolid() {
    _classCallCheck(this, IconWindowsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconWindowsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWindows",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWindowsSolid.displayName = "IconWindowsSolid";
  return IconWindowsSolid;
}(Component);

IconWindowsSolid.glyphName = 'windows';
IconWindowsSolid.variant = 'Solid';
IconWindowsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWindowsSolid;
export { IconWindowsSolid };